const Reveal = (({ jQuery: $ }) => {
    class Reveal {
        constructor($node) {
            this.$node = $($node);
            this.$revealContainer = $('[data-js="reveal-container"]');
            this.$items = this.$revealContainer.find('li');
            this.showOnInit = 4;
            this.revealLength = this.$items.length - this.showOnInit;
        }

        initReveal() {
            this.$items.hide();
            this.$items.slice(0, this.showOnInit).show();
        }

        slideDown(e) {
            e.preventDefault();
            $(this.$revealContainer.find('li:hidden'))
                .slice(0, this.revealLength)
                .slideDown();
            this.$node.fadeOut(500);
        }

        setEventBindings() {
            this.$node.on('click', this.slideDown.bind(this));
        }

        init() {
            this.initReveal();
            this.setEventBindings();
        }
    }

    return {
        init({ selector }) {
            return new Reveal(selector).init();
        },
    };
})(window);

export default Object.create(Reveal);
